// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// services
import {
	getCurrentAccessToken,
	fetchAccessToken,
	getReferenceId,
	AuthService,
	AuthOnBehalfOfConfig,
	Token,
	AuthReference,
	AuthStatus,
	clearToken,
	Error400Response,
	getKrogerAuthReference,
	CartItem,
	createCart,
} from '@andromeda/polaris-data-access-products';

// models
import { Partner } from '@/interfaces/Partner';
import { CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { ProductShoppingListItem } from '@/interfaces/ProductShoppingListItem';
import MxrRetailer from '@/interfaces/MxrRetailer';

// store
import {
	GET_KROGER_AUTH_CONFIG,
	SET_GO_TO_CART_OPEN,
	GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS,
	GET_IS_DEFAULT,
	GET_CURRENT_MXR_RETAILER,
	GET_THIRD_TAB_CLICK_REPORT,
	SEND_REPORT,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
	SET_CHECKOUT_TOTAL,
	SET_OFFERS_COUNT_IN_CART,
	GET_CARTING_URL,
} from '@/store/types';
import store from '@/store';

import { VuexAction } from '@/@types/index.d';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class kroger extends Vue {
	gamRedirect: string;

	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Prop() showCheckoutTotal!: boolean;

	@Prop() defaultUrl!: string;

	@Getter(GET_CARTING_URL) getCartingUrl!: string;

	@Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

	@Getter(GET_IS_DEFAULT) getIsDefault!: boolean;

	@Getter(GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS)
	getSelectedProductShoppingListItems!: ProductShoppingListItem[];

	@Getter(GET_KROGER_AUTH_CONFIG) getKrogerAuthConfig!: AuthOnBehalfOfConfig;

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SET_GO_TO_CART_OPEN) setGoToCartOpen!: VuexAction<boolean>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	@Action(SET_CHECKOUT_TOTAL) setCheckoutTotal: (
		payload: number
	) => VuexAction<void>;

	@Action(SET_OFFERS_COUNT_IN_CART) setOffersCountInCart: (
		payload: number
	) => VuexAction<void>;

	public loading = false;

	get price(): string {
		const prices: number[] = [];
		this.getSelectedProductShoppingListItems.forEach((p) => {
			const price = parseFloat(p.Price.substr(1, p.Price.length));
			if (!isNaN(price)) {
				prices.push(price);
			}
		});
		const total: string = prices.reduce((a, b) => a + b, 0).toFixed(2);
		this.setCheckoutTotal(Number.parseFloat(total));
		this.setOffersCountInCart(prices.length);
		return `Total: $${total}`;
	}

	// Use this for the actual button click event so we don't fire off telemetry
	// multiple times
	onClick() {
		this.sendClickReports();
		this.handleClick();
	}

	async handleClick() {
		if (this.getIsDefault) {
			window.open(this.defaultUrl, '_blank');
			return;
		}
		this.loading = true;

		try {
			const cartingUrl = this.getCartingUrl;
			if (!cartingUrl) {
				throw new Error('No carting url');
			}
			const url = this.gamRedirect ? `${this.gamRedirect}${encodeURIComponent(cartingUrl)}` : cartingUrl;
			window.open(url, '_blank');
			this.loading = false;
		} catch (error) {
			console.error('[KROGER CART]', error);
			this.loading = false;
		}
	}

	sendClickReports() {
		this.sendReport(this.getFooterButtonClickedReport);

		// Since they are going through the checkout don't bother with the CtaClickTelemetry
		if (!this.getIsDefault) return;

		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			partner: Partner.KROGER,
		};
		this.sendReport(report);
	}

	created() {
        if (window.sm_params) {
			this.gamRedirect = window.sm_params.smcuu
				? window.sm_params.smcuu
				: window.sm_params.smcue;
		}
    }
}
